<template>
    <div>
        <div class="inner-header">
            <nav class="navbar fixed-top animate__animated animate__slideInRight">
                <a @click="$router.go(-1)" class="back-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
                        <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                            <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none"
                                stroke="#000" stroke-width="2" />
                            <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15"
                                transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2" />
                        </g>
                    </svg>
                </a>
                <a href="javascript:void(0);" class="link-title">Project Details</a>
            </nav>
        </div>
        <div class="inner-page animate__animated animate__slideInRight">
            <div class="container-fluid">
                <div class="row">
                    <!-- Enquiry Card -->
                    <div class="col-12">
                        <div class="card details-card">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-12">
                                        <span class="lead-title" v-if="ProjectDetails.name">{{ProjectDetails.name}}</span>
                                        <span class="sub-title" v-if="ProjectDetails.builder">{{ProjectDetails.builder}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-6" v-if="ProjectDetails.locality">
                                        <span class="enq-title">Locality</span>
                                        <span class="enq-details">{{ProjectDetails.locality}}</span>
                                    </div>
                                    <div class="col-6" v-if="ProjectDetails.rera_id">
                                        <span class="enq-title">RERA ID</span>
                                        <span class="enq-details">{{ProjectDetails.rera_id}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-btn">
                            <div class="row">
                                <div class="col-6 pr-2">
                                    <router-link class="btn btn-white btn-block" :class="ProjectDetails.total_campaign===0 ? 'disabled' : ''" :to="{ name: 'Campaign', params: { id: this.queryP.id }}">
                                        <img src="@/assets/right-arrow.svg" alt="" class="right-arrow">
                                        <span class="enq-title">Total Campaigns</span>
                                        <span class="enq-details text-link">{{ProjectDetails.total_campaign}}</span>
                                       
                                    </router-link>
                                </div>
                                <div class="col-6 pl-2">
                                    <router-link class="btn btn-white btn-block" :class="ProjectDetails.interested_brokers===0 ? 'disabled' : ''" :to="{ name: 'InterestedBroker', params: { id: this.queryP.id }}">
                                        <img src="@/assets/right-arrow.svg" alt="" class="right-arrow">
                                        <span class="enq-title">Interested Brokers</span>
                                        <span class="enq-details text-link">{{ProjectDetails.interested_brokers}}</span>
                                    </router-link>
                                </div>
                                <div class="col-12 mt-3">
                                    <router-link :to="{ name: 'BrokerInitiation', params: { id: this.queryP.id }}" class="btn btn-primary btn-block"><img src="@/assets/broker-user-icon.svg" alt="" class="m-fix mr-1"> Broker Initiation</router-link>
                                </div>
                            </div>
                        </div>
                        <div class="card details-card mt-3">
                            <div class="card-body">
                              <div class="row">
                                  <div class="col-12">
                                      <span class="enq-title">Brokerage Slab</span>
                                      <span class="enq-details">{{ProjectDetails.project_informations.brokerage_slab || '-'}}</span>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <div class="card details-card mt-3">
                            <div class="card-header card-body">
                                  <div class="row">
                                    <div class="col-12">
                                        <span class="enq-title m-0">Project Information</span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12">
                                        <span class="enq-title">Artistic Impression</span>
                                        <div class="overlay-image">
                                            <img src="@/assets/Rectangle.png" alt="" class="img-fluid gallery-pic"/>
                                            <router-link :to="{ name: 'Impression', params: { id: this.$route.params.id }}" class="btn-view">View All</router-link>
                                        </div>
                                        
                                    </div>
                                    <div class="col-12" v-if="links.length > 0">
                                        <span class="enq-title">Links</span>
                                        <div class="d-flex justify-content-between"  v-for="(link, key) in links" :key="key">
                                            <span class="enq-details">{{link.title}}</span>
                                            <a @click="open_link(link.url)" class="cursor-pointer"><img src="@/assets/copy-icon.svg" alt=""></a>
                                        </div>
                                    </div>
                                    <div class="col-12" v-if="ProjectDetails.project_informations.brouchure_file_name">
                                        <span class="enq-title">Brochure</span>
                                        <div class="d-flex justify-content-between">
                                        <span class="enq-details">{{ProjectDetails.project_informations.brouchure_file_name}}</span>
                                        <a :href="ProjectDetails.project_informations.brouchure_url" target="_blank" :download="ProjectDetails.project_informations.brouchure_url"><img src="@/assets/download-icon.svg" alt=""></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'ProjectDetails',
  data() {
    return {
      queryP: {},
      ProjectDetails: {
        project_informations:{}
      },
      Projectid: '',
      links: []
    }
  },
  created () {
    this.FetchProjectDetails()
  },
  methods: {
    async open_link(url) {
      try {
        await navigator.clipboard.writeText(`${url}`);
        alert('copy to clipboard')
      } catch (e) {
          console.log(e);
      }
    },
    FetchProjectDetails() {
    this.queryP['id'] = this.$route.params.id;
    this.queryP['building_broker_id'] = this.$route.params.building_broker_id;
    this.$axios.get(`buildings/show_buildings`, { params: this.queryP }).then((res) => {
        this.ProjectDetails = JSON.parse(JSON.stringify(res.data).substring(1, JSON.stringify(res.data).length-1));
        this.links = this.ProjectDetails.project_informations.link_url
      });
    }
  }
}
</script>
<style scoped>
    .inner-page {
        margin-top: 60px;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .overlay-image {
        position: relative;
        margin: 10px 0;
        max-width: 767px;
    }
    .overlay-image::after{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4));
        border-radius: 6px;
        
    }
    .overlay-image .gallery-pic{
        object-fit: cover;
        width: 100%;
        max-width: 767px;
        max-height: 160px;
        object-position: center;
        border-radius: 6px;
    }
    .btn-view{
        background: rgba(0, 0, 0, 0.4);
        
       
        border-radius: 34px;
        font-weight: 500;
        font-size: 14px;
        text-align: center;
        letter-spacing: 0.1px;
        color: #FFFFFF;
        text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.4);
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        padding: 8px 15px;
        z-index: 9;
    }
</style>